var map = {
	"./0xbtc.svg": [
		855,
		3
	],
	"./1inch.svg": [
		856,
		4
	],
	"./1st.svg": [
		857,
		5
	],
	"./aave.svg": [
		858,
		6
	],
	"./abbc.svg": [
		859,
		7
	],
	"./abt.svg": [
		860,
		8
	],
	"./ac3.svg": [
		861,
		9
	],
	"./act.svg": [
		862,
		10
	],
	"./ada.svg": [
		863,
		11
	],
	"./adb.svg": [
		864,
		12
	],
	"./adx.svg": [
		865,
		13
	],
	"./ae.svg": [
		866,
		14
	],
	"./aeon.svg": [
		867,
		15
	],
	"./aergo.svg": [
		868,
		16
	],
	"./agi.svg": [
		869,
		17
	],
	"./aion.svg": [
		870,
		18
	],
	"./ait.svg": [
		871,
		19
	],
	"./akro.svg": [
		872,
		20
	],
	"./akt.svg": [
		873,
		21
	],
	"./aleph.svg": [
		874,
		22
	],
	"./algo.svg": [
		875,
		23
	],
	"./alis.svg": [
		876,
		24
	],
	"./alpha.svg": [
		877,
		25
	],
	"./alx.svg": [
		878,
		26
	],
	"./amb.svg": [
		879,
		27
	],
	"./amlt.svg": [
		880,
		28
	],
	"./ampl.svg": [
		881,
		29
	],
	"./anc.svg": [
		882,
		30
	],
	"./anj.svg": [
		883,
		31
	],
	"./ankr.svg": [
		884,
		32
	],
	"./ant.svg": [
		885,
		33
	],
	"./aph.svg": [
		886,
		34
	],
	"./apl.svg": [
		887,
		35
	],
	"./appc.svg": [
		888,
		36
	],
	"./apy.svg": [
		889,
		37
	],
	"./ar.svg": [
		890,
		38
	],
	"./ardr.svg": [
		891,
		39
	],
	"./ark.svg": [
		892,
		40
	],
	"./arn.svg": [
		893,
		41
	],
	"./aro.svg": [
		894,
		42
	],
	"./arrr.svg": [
		895,
		43
	],
	"./ast.svg": [
		896,
		44
	],
	"./atmi.svg": [
		897,
		45
	],
	"./atom.svg": [
		898,
		46
	],
	"./auc.svg": [
		899,
		47
	],
	"./aura.svg": [
		900,
		48
	],
	"./avax.svg": [
		901,
		49
	],
	"./awc.svg": [
		902,
		50
	],
	"./axp.svg": [
		903,
		51
	],
	"./bac.svg": [
		904,
		52
	],
	"./bal.svg": [
		905,
		53
	],
	"./bam.svg": [
		906,
		54
	],
	"./band.svg": [
		907,
		55
	],
	"./bao.svg": [
		908,
		56
	],
	"./bat.svg": [
		909,
		57
	],
	"./bay.svg": [
		910,
		58
	],
	"./bbr.svg": [
		911,
		59
	],
	"./bcd.svg": [
		912,
		60
	],
	"./bch.svg": [
		913,
		61
	],
	"./bcn.svg": [
		914,
		62
	],
	"./bco.svg": [
		915,
		63
	],
	"./bf.svg": [
		916,
		64
	],
	"./bifi.svg": [
		917,
		65
	],
	"./bix.svg": [
		918,
		66
	],
	"./block.svg": [
		919,
		67
	],
	"./blt.svg": [
		920,
		68
	],
	"./blue.svg": [
		921,
		69
	],
	"./blz.svg": [
		922,
		70
	],
	"./bnb.svg": [
		923,
		71
	],
	"./bnt.svg": [
		924,
		72
	],
	"./bond.svg": [
		925,
		73
	],
	"./bora.svg": [
		926,
		74
	],
	"./box.svg": [
		927,
		75
	],
	"./bpt.svg": [
		928,
		76
	],
	"./bqx.svg": [
		929,
		77
	],
	"./brd.svg": [
		930,
		78
	],
	"./btc++.svg": [
		931,
		79
	],
	"./btc.svg": [
		932,
		80
	],
	"./btcd.svg": [
		933,
		81
	],
	"./btcp.svg": [
		934,
		82
	],
	"./btg.svg": [
		935,
		83
	],
	"./btmx.svg": [
		936,
		84
	],
	"./bto.svg": [
		937,
		85
	],
	"./bts.svg": [
		938,
		86
	],
	"./btt.svg": [
		939,
		87
	],
	"./btu.svg": [
		940,
		88
	],
	"./bu.svg": [
		941,
		89
	],
	"./busd.svg": [
		942,
		90
	],
	"./bwt.svg": [
		943,
		91
	],
	"./bz.svg": [
		944,
		92
	],
	"./bznt.svg": [
		945,
		93
	],
	"./bzrx.svg": [
		946,
		94
	],
	"./c20.svg": [
		947,
		95
	],
	"./cake.svg": [
		948,
		96
	],
	"./capp.svg": [
		949,
		97
	],
	"./car.svg": [
		950,
		98
	],
	"./card.svg": [
		951,
		99
	],
	"./cbat.svg": [
		952,
		100
	],
	"./cbc.svg": [
		953,
		101
	],
	"./cbt.svg": [
		954,
		102
	],
	"./cccx.svg": [
		955,
		103
	],
	"./cdai.svg": [
		956,
		104
	],
	"./cdt.svg": [
		957,
		105
	],
	"./cel.svg": [
		958,
		106
	],
	"./celr.svg": [
		959,
		107
	],
	"./cennz.svg": [
		960,
		108
	],
	"./ceth.svg": [
		961,
		109
	],
	"./cfx.svg": [
		962,
		110
	],
	"./chai.svg": [
		963,
		111
	],
	"./chat.svg": [
		964,
		112
	],
	"./chsb.svg": [
		965,
		113
	],
	"./chz.svg": [
		966,
		114
	],
	"./ckb.svg": [
		967,
		115
	],
	"./clo.svg": [
		968,
		116
	],
	"./cloak.svg": [
		969,
		117
	],
	"./cmt.svg": [
		970,
		118
	],
	"./cnd.svg": [
		971,
		119
	],
	"./cnx.svg": [
		972,
		120
	],
	"./comp.svg": [
		973,
		121
	],
	"./coni.svg": [
		974,
		122
	],
	"./cosm.svg": [
		975,
		123
	],
	"./coti.svg": [
		976,
		124
	],
	"./cov.svg": [
		977,
		125
	],
	"./cova.svg": [
		978,
		126
	],
	"./cpc.svg": [
		979,
		127
	],
	"./cpx.svg": [
		980,
		128
	],
	"./cre.svg": [
		981,
		129
	],
	"./cream.svg": [
		982,
		130
	],
	"./cred.svg": [
		983,
		131
	],
	"./crep.svg": [
		984,
		132
	],
	"./cro.svg": [
		985,
		133
	],
	"./crpt.svg": [
		986,
		134
	],
	"./crv.svg": [
		987,
		135
	],
	"./cs.svg": [
		988,
		136
	],
	"./csai.svg": [
		989,
		137
	],
	"./csc.svg": [
		990,
		138
	],
	"./ctc.svg": [
		991,
		139
	],
	"./ctxc.svg": [
		992,
		140
	],
	"./cube.svg": [
		993,
		141
	],
	"./cusdc.svg": [
		994,
		142
	],
	"./cv.svg": [
		995,
		143
	],
	"./cvc.svg": [
		996,
		144
	],
	"./cvt.svg": [
		997,
		145
	],
	"./cwbtc.svg": [
		998,
		146
	],
	"./czrx.svg": [
		999,
		147
	],
	"./dadi.svg": [
		1000,
		148
	],
	"./dag.svg": [
		1001,
		149
	],
	"./dai.svg": [
		1002,
		150
	],
	"./dasc.svg": [
		1003,
		151
	],
	"./dash.svg": [
		1004,
		152
	],
	"./dat.svg": [
		1005,
		153
	],
	"./data.svg": [
		1006,
		154
	],
	"./datx.svg": [
		1007,
		155
	],
	"./dbc.svg": [
		1008,
		156
	],
	"./dcc.svg": [
		1009,
		157
	],
	"./dcn.svg": [
		1010,
		158
	],
	"./dcr.svg": [
		1011,
		159
	],
	"./dct.svg": [
		1012,
		160
	],
	"./ddd.svg": [
		1013,
		161
	],
	"./default.svg": [
		356
	],
	"./dent.svg": [
		1014,
		162
	],
	"./dfi.svg": [
		1015,
		163
	],
	"./dft.svg": [
		1016,
		164
	],
	"./dgb.svg": [
		1017,
		165
	],
	"./dgd.svg": [
		1018,
		166
	],
	"./dgtx.svg": [
		1019,
		167
	],
	"./divi.svg": [
		1020,
		168
	],
	"./dlt.svg": [
		1021,
		169
	],
	"./dmt.svg": [
		1022,
		170
	],
	"./dnt.svg": [
		1023,
		171
	],
	"./dock.svg": [
		1024,
		172
	],
	"./dodo.svg": [
		1025,
		173
	],
	"./doge.svg": [
		1026,
		174
	],
	"./dor.svg": [
		1027,
		175
	],
	"./dot.svg": [
		1028,
		176
	],
	"./drgn.svg": [
		1029,
		177
	],
	"./drop.svg": [
		1030,
		178
	],
	"./dta.svg": [
		1031,
		179
	],
	"./dtr.svg": [
		1032,
		180
	],
	"./dtx.svg": [
		1033,
		181
	],
	"./dxt.svg": [
		1034,
		182
	],
	"./edg.svg": [
		1035,
		183
	],
	"./edo.svg": [
		1036,
		184
	],
	"./efx.svg": [
		1037,
		185
	],
	"./egld.svg": [
		1038,
		186
	],
	"./egt.svg": [
		1039,
		187
	],
	"./ekg.svg": [
		1040,
		188
	],
	"./ekt.svg": [
		1041,
		189
	],
	"./ela.svg": [
		1042,
		190
	],
	"./elec.svg": [
		1043,
		191
	],
	"./elf.svg": [
		1044,
		192
	],
	"./emc.svg": [
		1045,
		193
	],
	"./emc2.svg": [
		1046,
		194
	],
	"./eng.svg": [
		1047,
		195
	],
	"./enj.svg": [
		1048,
		196
	],
	"./eos.svg": [
		1049,
		197
	],
	"./eosdac.svg": [
		1050,
		198
	],
	"./erd.svg": [
		1051,
		199
	],
	"./ern.svg": [
		1052,
		200
	],
	"./esd.svg": [
		1053,
		201
	],
	"./esp.svg": [
		1054,
		202
	],
	"./ess.svg": [
		1055,
		203
	],
	"./etc.svg": [
		1056,
		204
	],
	"./eth.svg": [
		1057,
		205
	],
	"./etn.svg": [
		1058,
		206
	],
	"./etp.svg": [
		1059,
		207
	],
	"./etz.svg": [
		1060,
		208
	],
	"./evx.svg": [
		1061,
		209
	],
	"./ewt.svg": [
		1062,
		210
	],
	"./exrn.svg": [
		1063,
		211
	],
	"./exy.svg": [
		1064,
		212
	],
	"./fct.svg": [
		1065,
		213
	],
	"./fet.svg": [
		1066,
		214
	],
	"./fil.svg": [
		1067,
		215
	],
	"./flow.svg": [
		1068,
		216
	],
	"./fota.svg": [
		1069,
		217
	],
	"./frm.svg": [
		1070,
		218
	],
	"./fsn.svg": [
		1071,
		219
	],
	"./ft.svg": [
		1072,
		220
	],
	"./ftm.svg": [
		1073,
		221
	],
	"./ftt.svg": [
		1074,
		222
	],
	"./fuel.svg": [
		1075,
		223
	],
	"./fun.svg": [
		1076,
		224
	],
	"./fxc.svg": [
		1077,
		225
	],
	"./fxt.svg": [
		1078,
		226
	],
	"./gala.svg": [
		1079,
		227
	],
	"./gdc.svg": [
		1080,
		228
	],
	"./gem.svg": [
		1081,
		229
	],
	"./gen.svg": [
		1082,
		230
	],
	"./gno.svg": [
		1083,
		231
	],
	"./gnt.svg": [
		1084,
		232
	],
	"./gnx.svg": [
		1085,
		233
	],
	"./go.svg": [
		1086,
		234
	],
	"./goc.svg": [
		1087,
		235
	],
	"./got.svg": [
		1088,
		236
	],
	"./grin.svg": [
		1089,
		237
	],
	"./grs.svg": [
		1090,
		238
	],
	"./grt.svg": [
		1091,
		239
	],
	"./gsc.svg": [
		1092,
		240
	],
	"./gt.svg": [
		1093,
		241
	],
	"./gtc.svg": [
		1094,
		242
	],
	"./gto.svg": [
		1095,
		243
	],
	"./gusd.svg": [
		1096,
		244
	],
	"./gvt.svg": [
		1097,
		245
	],
	"./gxs.svg": [
		1098,
		246
	],
	"./hav.svg": [
		1099,
		247
	],
	"./hbar.svg": [
		1100,
		248
	],
	"./hc.svg": [
		1101,
		249
	],
	"./hedg.svg": [
		1102,
		250
	],
	"./her.svg": [
		1103,
		251
	],
	"./hex.svg": [
		1104,
		252
	],
	"./hive.svg": [
		1105,
		253
	],
	"./hot-x.svg": [
		1106,
		254
	],
	"./hot.svg": [
		1107,
		255
	],
	"./hpb.svg": [
		1108,
		256
	],
	"./hsr.svg": [
		1109,
		257
	],
	"./ht.svg": [
		1110,
		258
	],
	"./hum.svg": [
		1111,
		259
	],
	"./husd.svg": [
		1112,
		260
	],
	"./hvn.svg": [
		1113,
		261
	],
	"./hydro.svg": [
		1114,
		262
	],
	"./hyn.svg": [
		1115,
		263
	],
	"./ibat.svg": [
		1116,
		264
	],
	"./icn.svg": [
		1117,
		265
	],
	"./icx.svg": [
		1118,
		266
	],
	"./idai.svg": [
		1119,
		267
	],
	"./idex.svg": [
		1120,
		268
	],
	"./ieth.svg": [
		1121,
		269
	],
	"./ignis.svg": [
		1122,
		270
	],
	"./iknc.svg": [
		1123,
		271
	],
	"./ilink.svg": [
		1124,
		272
	],
	"./inb.svg": [
		1125,
		273
	],
	"./ins.svg": [
		1126,
		274
	],
	"./iost.svg": [
		1127,
		275
	],
	"./iota.svg": [
		1128,
		276
	],
	"./iotx.svg": [
		1129,
		277
	],
	"./iq.svg": [
		1130,
		278
	],
	"./irep.svg": [
		1131,
		279
	],
	"./iris.svg": [
		1132,
		280
	],
	"./isusd.svg": [
		1133,
		281
	],
	"./iusdc.svg": [
		1134,
		282
	],
	"./iwbtc.svg": [
		1135,
		283
	],
	"./izrx.svg": [
		1136,
		284
	],
	"./jnt.svg": [
		1137,
		285
	],
	"./jrt.svg": [
		1138,
		286
	],
	"./jst.svg": [
		1139,
		287
	],
	"./kava.svg": [
		1140,
		288
	],
	"./kcs.svg": [
		1141,
		289
	],
	"./keep.svg": [
		1142,
		290
	],
	"./key.svg": [
		1143,
		291
	],
	"./kick.svg": [
		1144,
		292
	],
	"./kin.svg": [
		1145,
		293
	],
	"./klv.svg": [
		1146,
		294
	],
	"./kmd.svg": [
		1147,
		295
	],
	"./knc.svg": [
		1148,
		296
	],
	"./ksm.svg": [
		1149,
		297
	],
	"./lamb.svg": [
		1150,
		298
	],
	"./land.svg": [
		1151,
		299
	],
	"./lba.svg": [
		1152,
		300
	],
	"./ldo.svg": [
		1153,
		301
	],
	"./lend.svg": [
		1154,
		302
	],
	"./leo.svg": [
		1155,
		303
	],
	"./link.svg": [
		1156,
		304
	],
	"./lit.svg": [
		1157,
		305
	],
	"./lky.svg": [
		1158,
		306
	],
	"./loki.svg": [
		1159,
		307
	],
	"./lon.svg": [
		1160,
		308
	],
	"./loom.svg": [
		1161,
		309
	],
	"./lpt.svg": [
		1162,
		310
	],
	"./lqd.svg": [
		1163,
		311
	],
	"./lrc.svg": [
		1164,
		312
	],
	"./lsk.svg": [
		1165,
		313
	],
	"./ltc.svg": [
		1166,
		314
	],
	"./lto.svg": [
		1167,
		315
	],
	"./lun.svg": [
		1168,
		316
	],
	"./luna.svg": [
		1169,
		317
	],
	"./lxt.svg": [
		1170,
		318
	],
	"./lym.svg": [
		1171,
		319
	],
	"./maid.svg": [
		1172,
		320
	],
	"./man.svg": [
		1173,
		321
	],
	"./mana-old.svg": [
		1174,
		322
	],
	"./mana.svg": [
		1175,
		323
	],
	"./math.svg": [
		1176,
		324
	],
	"./matic.svg": [
		1177,
		325
	],
	"./mbc.svg": [
		1178,
		326
	],
	"./mco.svg": [
		1179,
		327
	],
	"./mcx.svg": [
		1180,
		328
	],
	"./mda.svg": [
		1181,
		329
	],
	"./mds.svg": [
		1182,
		330
	],
	"./med.svg": [
		1183,
		331
	],
	"./medx.svg": [
		1184,
		332
	],
	"./met.svg": [
		1185,
		333
	],
	"./mfg.svg": [
		1186,
		334
	],
	"./mft.svg": [
		1187,
		335
	],
	"./mir.svg": [
		1188,
		336
	],
	"./mith.svg": [
		1189,
		337
	],
	"./mkr.svg": [
		1190,
		338
	],
	"./mln.svg": [
		1191,
		339
	],
	"./mod.svg": [
		1192,
		340
	],
	"./mot.svg": [
		1193,
		341
	],
	"./mta.svg": [
		1194,
		342
	],
	"./mth.svg": [
		1195,
		343
	],
	"./mtl.svg": [
		1196,
		344
	],
	"./mtn.svg": [
		1197,
		345
	],
	"./mvc.svg": [
		1198,
		346
	],
	"./mvl.svg": [
		1199,
		347
	],
	"./mvp.svg": [
		1200,
		348
	],
	"./mwat.svg": [
		1201,
		349
	],
	"./mwc.svg": [
		1202,
		350
	],
	"./mxm.svg": [
		1203,
		351
	],
	"./myb.svg": [
		1204,
		352
	],
	"./nano.svg": [
		1205,
		353
	],
	"./nas.svg": [
		1206,
		354
	],
	"./nav.svg": [
		1207,
		355
	],
	"./ncash.svg": [
		1208,
		356
	],
	"./nct.svg": [
		1209,
		357
	],
	"./near.svg": [
		1210,
		358
	],
	"./nebl.svg": [
		1211,
		359
	],
	"./nec.svg": [
		1212,
		360
	],
	"./neo.svg": [
		1213,
		361
	],
	"./new.svg": [
		1214,
		362
	],
	"./nex.svg": [
		1215,
		363
	],
	"./nexo.svg": [
		1216,
		364
	],
	"./nexxo.svg": [
		1217,
		365
	],
	"./ngc.svg": [
		1218,
		366
	],
	"./nkn.svg": [
		1219,
		367
	],
	"./nmr.svg": [
		1220,
		368
	],
	"./noia.svg": [
		1221,
		369
	],
	"./nper.svg": [
		1222,
		370
	],
	"./npxs.svg": [
		1223,
		371
	],
	"./nrg.svg": [
		1224,
		372
	],
	"./nrve.svg": [
		1225,
		373
	],
	"./nu.svg": [
		1226,
		374
	],
	"./nuls.svg": [
		1227,
		375
	],
	"./nxs.svg": [
		1228,
		376
	],
	"./nxt.svg": [
		1229,
		377
	],
	"./oag.svg": [
		1230,
		378
	],
	"./oax.svg": [
		1231,
		379
	],
	"./ocean.svg": [
		1232,
		380
	],
	"./ocn.svg": [
		1233,
		381
	],
	"./ode.svg": [
		1234,
		382
	],
	"./ogn.svg": [
		1235,
		383
	],
	"./okb.svg": [
		1236,
		384
	],
	"./olt.svg": [
		1237,
		385
	],
	"./omg.svg": [
		1238,
		386
	],
	"./one.svg": [
		1239,
		387
	],
	"./onion.svg": [
		1240,
		388
	],
	"./ont.svg": [
		1241,
		389
	],
	"./open.svg": [
		1242,
		390
	],
	"./orbs.svg": [
		1243,
		391
	],
	"./orc.svg": [
		1244,
		392
	],
	"./orn.svg": [
		1245,
		393
	],
	"./ost.svg": [
		1246,
		394
	],
	"./ovc.svg": [
		1247,
		395
	],
	"./oxt.svg": [
		1248,
		396
	],
	"./pBTC.svg": [
		1249,
		397
	],
	"./pai.svg": [
		1250,
		398
	],
	"./pal.svg": [
		1251,
		399
	],
	"./part.svg": [
		1252,
		400
	],
	"./pax.svg": [
		1253,
		401
	],
	"./paxg.svg": [
		1254,
		402
	],
	"./pay.svg": [
		1255,
		403
	],
	"./perl.svg": [
		1256,
		404
	],
	"./pivx.svg": [
		1257,
		405
	],
	"./plDAI.svg": [
		1258,
		406
	],
	"./plUSDC.svg": [
		1259,
		407
	],
	"./play.svg": [
		1260,
		408
	],
	"./plr.svg": [
		1261,
		409
	],
	"./png.svg": [
		1262,
		410
	],
	"./pnk.svg": [
		1263,
		411
	],
	"./pnt.svg": [
		1264,
		412
	],
	"./poa.svg": [
		1265,
		413
	],
	"./poe.svg": [
		1266,
		414
	],
	"./poly.svg": [
		1267,
		415
	],
	"./pond.svg": [
		1268,
		416
	],
	"./powr.svg": [
		1269,
		417
	],
	"./ppay.svg": [
		1270,
		418
	],
	"./ppc.svg": [
		1271,
		419
	],
	"./ppp.svg": [
		1272,
		420
	],
	"./ppt.svg": [
		1273,
		421
	],
	"./pre.svg": [
		1274,
		422
	],
	"./prl.svg": [
		1275,
		423
	],
	"./pro.svg": [
		1276,
		424
	],
	"./prq.svg": [
		1277,
		425
	],
	"./pst.svg": [
		1278,
		426
	],
	"./qash.svg": [
		1279,
		427
	],
	"./qbit.svg": [
		1280,
		428
	],
	"./qkc.svg": [
		1281,
		429
	],
	"./qlc.svg": [
		1282,
		430
	],
	"./qnt.svg": [
		1283,
		431
	],
	"./qsp.svg": [
		1284,
		432
	],
	"./qtum.svg": [
		1285,
		433
	],
	"./r.svg": [
		1286,
		434
	],
	"./rae.svg": [
		1287,
		435
	],
	"./rari.svg": [
		1288,
		436
	],
	"./ray.svg": [
		1289,
		437
	],
	"./rcn.svg": [
		1290,
		438
	],
	"./rdd.svg": [
		1291,
		439
	],
	"./rdn.svg": [
		1292,
		440
	],
	"./ren.svg": [
		1293,
		441
	],
	"./rep.svg": [
		1294,
		442
	],
	"./req.svg": [
		1295,
		443
	],
	"./rev.svg": [
		1296,
		444
	],
	"./rfox.svg": [
		1297,
		445
	],
	"./rhoc.svg": [
		1298,
		446
	],
	"./rif.svg": [
		1299,
		447
	],
	"./rlc.svg": [
		1300,
		448
	],
	"./rose.svg": [
		1301,
		449
	],
	"./rpx.svg": [
		1302,
		450
	],
	"./rsr.svg": [
		1303,
		451
	],
	"./rsv.svg": [
		1304,
		452
	],
	"./rune.svg": [
		1305,
		453
	],
	"./rvn.svg": [
		1306,
		454
	],
	"./s.svg": [
		1307,
		455
	],
	"./sai.svg": [
		1308,
		456
	],
	"./salt.svg": [
		1309,
		457
	],
	"./san.svg": [
		1310,
		458
	],
	"./scrl.svg": [
		1311,
		459
	],
	"./scrt.svg": [
		1312,
		460
	],
	"./seele.svg": [
		1313,
		461
	],
	"./sem.svg": [
		1314,
		462
	],
	"./sfp.svg": [
		1315,
		463
	],
	"./shr.svg": [
		1316,
		464
	],
	"./shuf.svg": [
		1317,
		465
	],
	"./sia.svg": [
		1318,
		466
	],
	"./skl.svg": [
		1319,
		467
	],
	"./sky.svg": [
		1320,
		468
	],
	"./slt.svg": [
		1321,
		469
	],
	"./smart.svg": [
		1322,
		470
	],
	"./snc.svg": [
		1323,
		471
	],
	"./sngls.svg": [
		1324,
		472
	],
	"./snm.svg": [
		1325,
		473
	],
	"./snt.svg": [
		1326,
		474
	],
	"./snx.svg": [
		1327,
		475
	],
	"./sol.svg": [
		1328,
		476
	],
	"./soul.svg": [
		1329,
		477
	],
	"./spn.svg": [
		1330,
		478
	],
	"./srm.svg": [
		1331,
		479
	],
	"./stake.svg": [
		1332,
		480
	],
	"./steem.svg": [
		1333,
		481
	],
	"./steth.svg": [
		1334,
		482
	],
	"./stmx.svg": [
		1335,
		483
	],
	"./storj.svg": [
		1336,
		484
	],
	"./storm.svg": [
		1337,
		485
	],
	"./strat.svg": [
		1338,
		486
	],
	"./stx.svg": [
		1339,
		487
	],
	"./sub.svg": [
		1340,
		488
	],
	"./super.svg": [
		1341,
		489
	],
	"./suqa.svg": [
		1342,
		490
	],
	"./sushi.svg": [
		1343,
		491
	],
	"./suter.svg": [
		1344,
		492
	],
	"./swap.svg": [
		1345,
		493
	],
	"./swth.svg": [
		1346,
		494
	],
	"./sxdt.svg": [
		1347,
		495
	],
	"./sxp.svg": [
		1348,
		496
	],
	"./sys.svg": [
		1349,
		497
	],
	"./tct.svg": [
		1350,
		498
	],
	"./tel.svg": [
		1351,
		499
	],
	"./tfuel.svg": [
		1352,
		500
	],
	"./thc.svg": [
		1353,
		501
	],
	"./theta.svg": [
		1354,
		502
	],
	"./thr.svg": [
		1355,
		503
	],
	"./tio.svg": [
		1356,
		504
	],
	"./titan.svg": [
		1357,
		505
	],
	"./tkn.svg": [
		1358,
		506
	],
	"./tky.svg": [
		1359,
		507
	],
	"./tnb.svg": [
		1360,
		508
	],
	"./tnc.svg": [
		1361,
		509
	],
	"./tnt.svg": [
		1362,
		510
	],
	"./tomo.svg": [
		1363,
		511
	],
	"./tpay.svg": [
		1364,
		512
	],
	"./trac.svg": [
		1365,
		513
	],
	"./trb.svg": [
		1366,
		514
	],
	"./trig.svg": [
		1367,
		515
	],
	"./trtl.svg": [
		1368,
		516
	],
	"./trx.svg": [
		1369,
		517
	],
	"./tryb.svg": [
		1370,
		518
	],
	"./ttc.svg": [
		1371,
		519
	],
	"./tube.svg": [
		1372,
		520
	],
	"./tusd.svg": [
		1373,
		521
	],
	"./ubq.svg": [
		1374,
		522
	],
	"./ubt.svg": [
		1375,
		523
	],
	"./ult.svg": [
		1376,
		524
	],
	"./uma.svg": [
		1377,
		525
	],
	"./unfi.svg": [
		1378,
		526
	],
	"./uni.svg": [
		1379,
		527
	],
	"./unn.svg": [
		1380,
		528
	],
	"./uos.svg": [
		1381,
		529
	],
	"./upp.svg": [
		1382,
		530
	],
	"./usd.svg": [
		1383,
		531
	],
	"./usdc.svg": [
		1384,
		532
	],
	"./usds.svg": [
		1385,
		533
	],
	"./usdt.svg": [
		1386,
		534
	],
	"./utk.svg": [
		1387,
		535
	],
	"./uuu.svg": [
		1388,
		536
	],
	"./veri.svg": [
		1389,
		537
	],
	"./vest.svg": [
		1390,
		538
	],
	"./vet.svg": [
		1391,
		539
	],
	"./via.svg": [
		1392,
		540
	],
	"./vib.svg": [
		1393,
		541
	],
	"./vibe.svg": [
		1394,
		542
	],
	"./vidt.svg": [
		1395,
		543
	],
	"./vikky.svg": [
		1396,
		544
	],
	"./vin.svg": [
		1397,
		545
	],
	"./vite.svg": [
		1398,
		546
	],
	"./viu.svg": [
		1399,
		547
	],
	"./vlx.svg": [
		1400,
		548
	],
	"./vrs.svg": [
		1401,
		549
	],
	"./vsp.svg": [
		1402,
		550
	],
	"./vsys.svg": [
		1403,
		551
	],
	"./vtc.svg": [
		1404,
		552
	],
	"./wabi.svg": [
		1405,
		553
	],
	"./wan.svg": [
		1406,
		554
	],
	"./waves.svg": [
		1407,
		555
	],
	"./wbtc.svg": [
		1408,
		556
	],
	"./wct.svg": [
		1409,
		557
	],
	"./whale.svg": [
		1410,
		558
	],
	"./wib.svg": [
		1411,
		559
	],
	"./wings.svg": [
		1412,
		560
	],
	"./woo.svg": [
		1413,
		561
	],
	"./wpr.svg": [
		1414,
		562
	],
	"./wrx.svg": [
		1415,
		563
	],
	"./wtc.svg": [
		1416,
		564
	],
	"./wxt.svg": [
		1417,
		565
	],
	"./xas.svg": [
		1418,
		566
	],
	"./xchf.svg": [
		1419,
		567
	],
	"./xem.svg": [
		1420,
		568
	],
	"./xin.svg": [
		1421,
		569
	],
	"./xlm.svg": [
		1422,
		570
	],
	"./xlq.svg": [
		1423,
		571
	],
	"./xmark.svg": [
		1424,
		572
	],
	"./xmr.svg": [
		1425,
		573
	],
	"./xmx.svg": [
		1426,
		574
	],
	"./xnk.svg": [
		1427,
		575
	],
	"./xns.svg": [
		1428,
		576
	],
	"./xor.svg": [
		1429,
		577
	],
	"./xrp.svg": [
		1430,
		578
	],
	"./xsn.svg": [
		1431,
		579
	],
	"./xsr.svg": [
		1432,
		580
	],
	"./xtz.svg": [
		1433,
		581
	],
	"./xvg.svg": [
		1434,
		582
	],
	"./xyo.svg": [
		1435,
		583
	],
	"./xzc.svg": [
		1436,
		584
	],
	"./yfi.svg": [
		1437,
		585
	],
	"./yoyo.svg": [
		1438,
		586
	],
	"./zai.svg": [
		1439,
		587
	],
	"./zb.svg": [
		1440,
		588
	],
	"./zco.svg": [
		1441,
		589
	],
	"./zec.svg": [
		1442,
		590
	],
	"./zel.svg": [
		1443,
		591
	],
	"./zen.svg": [
		1444,
		592
	],
	"./zil.svg": [
		1445,
		593
	],
	"./zks.svg": [
		1446,
		594
	],
	"./zrx.svg": [
		1447,
		595
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 727;
module.exports = webpackAsyncContext;